import { useTranslation } from 'react-i18next'

import { preventDefault } from '../../../utils/events'
import { ICON_HEIGHT_16, IconWithTooltip } from '../../Icon'

import * as styles from './TextareaInlineActions.module.css'

import CloseIcon from '../../../icons/close.svg'
import InfoIcon from '../../../icons/info.svg'

function TextareaInlineActions({ clearable, disabled, info, onClear }) {
  const { t } = useTranslation()

  return (
    <div className={styles.textareaInlineActions}>
      {clearable && !disabled ? (
        <IconWithTooltip
          Icon={CloseIcon}
          className={styles.icon}
          size={ICON_HEIGHT_16}
          tooltip={t('Input.ClearTooltipKey')}
          onClick={onClear}
          onMouseDown={preventDefault} // needs to prevent `onBlur` action
        />
      ) : null}
      {info ? (
        <IconWithTooltip
          Icon={InfoIcon}
          className={styles.icon}
          size={ICON_HEIGHT_16}
          tooltip={info}
        />
      ) : null}
    </div>
  )
}

export default TextareaInlineActions
